import { request } from './repository';
import _ from 'lodash';

const url = 'support_tickets';

const supportTicketRepository = {
    fetchAllSupportTickets(params) {
        return request.get(url, params);
    },
    fetchSupportTicket(id) {
        return request.get(url + '/' + id);
    },
    createSupportTicket(data = null) {
        return request.post(url, data);
    },
    updateSupportTicket(data) {
        return request.put(url + '/' + data.id, _.omit(data, ['id']));
    },
    deleteSupportTicket(id) {
        return request.delete(url + '/' + id);
    },
    finishTreatment(ticket_number) {
        return request.put(url + `/finish_treatment/${ticket_number}`, null);
    }
}

export default supportTicketRepository;